import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { createTouchscreenQueryClient } from "@touchscreen/hooks";
import { App } from "./App.js";
import "./main.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root element missing from index.html");

const queryClient = createTouchscreenQueryClient();

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
